import { PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';
import colors from '../../../helpers/colors';
import fonts from '../../../helpers/fonts';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';
import Button, { GenericButtonProps } from '../../Button';
import { styledButton } from '../styles';

export type PageArrowProps = {
  shownOnMobile?: boolean;
  isNextArrow?: boolean;
} & PropsWithChildren<GenericButtonProps>;

const activePageArrow = css`
  && {
    color: ${colors.core01};
  }
  &:hover {
    text-decoration: underline;
    font-weight: bold;
    box-shadow: none;
    color: ${colors.core02};
  }
  &:focus-visible {
    font-weight: medium;
    box-shadow: none;
    border-color: ${colors.core01};
  }
  &:active {
    font-weight: medium;
    box-shadow: none;
    border-color: ${colors.core02};
  }
`;

export const PageArrowButton = styled(Button)<PageArrowProps>`
  span {
    display: flex;
    flex-direction: ${({ isNextArrow }) => (isNextArrow ? 'column-reverse' : 'column')};
    
    ${mediaQuery.tabletLandscape`      
    margin: 0 ${spacing(1)};
    `}
  }   
  
  ${styledButton}
  ${fonts.paragraphSmall};
  border-radius: ${spacing(1)};
  border: solid 2px transparent;
  padding: 0 ${spacing(0.5)};  

  ${({ disabled }) => (disabled ? 'cursor: default;' : activePageArrow)}

  ${mediaQuery.tabletPortrait`
      ${fonts.paragraph};
    `}

  ${mediaQuery.tabletLandscape`
      span{
        flex-direction: row;
      }
      ${fonts.headingXSmall};
      padding: ${spacing(1)} ${spacing(0.5)};
  `}
`;
